import { render, staticRenderFns } from "./ttfx.vue?vue&type=template&id=1b34d4a2&scoped=true"
import script from "./ttfx.vue?vue&type=script&lang=js"
export * from "./ttfx.vue?vue&type=script&lang=js"
import style0 from "./ttfx.vue?vue&type=style&index=0&id=1b34d4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34d4a2",
  null
  
)

export default component.exports